<!-- Page header -->
<div class="np-page-header">
  <button pButton type="button" class="p-button-text p-button-sm" title="Back to home" (click)="goBack()">
    <i class="pi pi-arrow-left"></i>
  </button>
  <span class="np-page-title">Pull Batches</span>
</div>

<div *ngIf="isPageReady" class="p-3 flex flex-col gap-3 h-full">
  <!-- Search -->
  <span class="p-input-icon-left w-full">
    <i class="pi pi-search"></i>
    <input
      pInputText
      type="text"
      [(ngModel)]="searchText"
      placeholder="Search by batch id, user, or account"
      class="w-full"
      title="Search batches"
    />
  </span>

  <!-- Count -->
  <div class="text-sm opacity-70">
    {{ filteredBatches.length }} batch{{ filteredBatches.length !== 1 ? 'es' : '' }}
  </div>

  <!-- Batch cards -->
  <div class="flex flex-col gap-3 overflow-y-auto flex-1">
    <div *ngFor="let batch of filteredBatches" class="np-card flex flex-col gap-3" (click)="openBatch(batch)">
      <div class="flex justify-between items-start">
        <div>
          <span class="text-lg font-bold">Batch {{ batch.id }}</span>
          <span class="ml-2 text-sm opacity-70">{{ batch.userInit }}</span>
        </div>
        <i class="pi pi-chevron-right opacity-40 text-lg"></i>
      </div>

      <div class="grid grid-cols-2 gap-x-4 gap-y-1">
        <div>
          <div class="np-card-label">Job Orders</div>
          <div class="np-card-value">{{ joCount(batch) }}</div>
        </div>
        <div>
          <div class="np-card-label">Accounts</div>
          <div class="np-card-value">{{ accountSummary(batch) }}</div>
        </div>
      </div>
    </div>

    <div *ngIf="filteredBatches.length === 0" class="text-center py-8 opacity-50">
      No batches found
    </div>
  </div>
</div>
